import React, { useEffect, useState } from 'react';
import Cookies from 'universal-cookie';
import { trackEvent, TRACKING_ENUMS } from 'Utils/Analytics';
import { fetchMobileRegcode } from 'Api/ProfileApi';
import { getDefaultConfig } from 'Utils/Store';
import './GetAppButton.css';

const cookies = new Cookies();

export const GetAppButton = ({ ctaText = '', isMobile }) => {
  const [regcode, setRegcode] = useState('');

  useEffect(() => {
    const retrieveRegcode = async (deviceId) => {
      const { code } = await fetchMobileRegcode(deviceId);
      setRegcode(code);
    };
    if (isMobile) {
      const { deviceIdCookieName } = getDefaultConfig();
      const deviceId = cookies.get(deviceIdCookieName);
      retrieveRegcode(deviceId);
    }
  }, [isMobile]);

  const openApp = () => {
    trackEvent(
      TRACKING_ENUMS.EVENT_DEVICE_LINK_BUTTON_CLICKED,
      {
        page_item_title: 'signup confirmation',
        page_ui_element: 'button',
      },
      {
        item_title: 'signup confirmation',
        button_text: ctaText,
        ui_element: 'button',
      }
    );
    window.location.assign(`https://foxnation.onelink.me/CbbD/InstallApp?deep_link_value_sub1=${regcode}`);
  };

  if (ctaText && isMobile) {
    return (
      <div className="get-app-button-container">
        <img
          src="/account/static/images/FN/watchAnywhere.png"
          className="device-images"
          width="312"
          height="218"
          alt="Mobile Device Images"
          onClick={openApp}
        />
        <button className="get-app-button" type="button" onClick={openApp}>
          {ctaText}
        </button>
      </div>
    );
  }
  return null;
};
